/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItDataTypeBooleanDto } from './TrackItDataTypeBooleanDto';
import {
    instanceOfTrackItDataTypeBooleanDto,
    TrackItDataTypeBooleanDtoFromJSON,
    TrackItDataTypeBooleanDtoFromJSONTyped,
    TrackItDataTypeBooleanDtoToJSON,
} from './TrackItDataTypeBooleanDto';
import type { TrackItDataTypeDoubleDto } from './TrackItDataTypeDoubleDto';
import {
    instanceOfTrackItDataTypeDoubleDto,
    TrackItDataTypeDoubleDtoFromJSON,
    TrackItDataTypeDoubleDtoFromJSONTyped,
    TrackItDataTypeDoubleDtoToJSON,
} from './TrackItDataTypeDoubleDto';
import type { TrackItDataTypeLongDto } from './TrackItDataTypeLongDto';
import {
    instanceOfTrackItDataTypeLongDto,
    TrackItDataTypeLongDtoFromJSON,
    TrackItDataTypeLongDtoFromJSONTyped,
    TrackItDataTypeLongDtoToJSON,
} from './TrackItDataTypeLongDto';

/**
 * @type TrackItDataTypeDto
 * 
 * @export
 */
export type TrackItDataTypeDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeBooleanDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItDataTypeBooleanDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItDataTypeDoubleDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItDataTypeLongDto;


export function TrackItDataTypeDtoFromJSON(json: any): TrackItDataTypeDto {
    return TrackItDataTypeDtoFromJSONTyped(json, false);
}

export function TrackItDataTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataTypeDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeBooleanDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItDataTypeBooleanDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeBooleanDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItDataTypeDoubleDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItDataTypeLongDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of TrackItDataTypeDto exists with '$type=${json['$type']}'`);
    }
}

export function TrackItDataTypeDtoToJSON(value?: TrackItDataTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeBooleanDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItDataTypeBooleanDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItDataTypeDoubleDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItDataTypeLongDtoToJSON(value);
        default:
            throw new Error(`No variant of TrackItDataTypeDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TrackItDataTypeDto interface.
 */
export function instanceOfTrackItDataTypeDto(value: any): value is TrackItDataTypeDto {
    if (instanceOfTrackItDataTypeBooleanDto(value)) return true;
    if (instanceOfTrackItDataTypeDoubleDto(value)) return true;
    if (instanceOfTrackItDataTypeLongDto(value)) return true;
    return false;
}

